import {Box} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import OrdersHOC from "./OrdersHOC";
import {OrdersDetailedCard} from "./order/OrdersDetailedCard";
import CreateOrder from "./createOrder/CreateOrder";
import {EditOrderHOC} from "./editOrder/EditOrderHOC";

export const OrdersMain = () => {
    return (<Box>
        <Routes>
            <Route index element={<OrdersHOC/>}/>
            <Route path="new" element={<CreateOrder/>}/>
            <Route path=":id" element={<OrdersDetailedCard/>}/>
            <Route path=":id/edit" element={<EditOrderHOC/>}/>
        </Routes>
    </Box>)
}
